import styled from "styled-components";
import Responsable from "../../../Responsable";

const Tirepick = () => {
  const srcRoot = '/image/webp/project/tirepick/content';

  return <><Responsable
    pc={
      <ContentContainer>
        <img src={`${srcRoot}/tirepick-pc-1.webp`} width={'100%'} />
      </ContentContainer>
    }
    tablet={
      <ContentContainer>
        <img src={`${srcRoot}/tirepick-tablet-1.png`} width={'100%'} />
      </ContentContainer>
    }
    mobile={
      <ContentContainer>
        <img src={`${srcRoot}/tirepick-mobile-1.png`} width={'100%'} />
      </ContentContainer>
    }
  /></>;
};

export { Tirepick };

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;

  img {
    margin-bottom: -1px;
    object-fit: cover;
  }
`;